import { ChangeDetectorRef,  Component,  EventEmitter,  Input,  OnDestroy,  OnInit,  Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { AudioRecordingService } from 'src/app/Service/audio-recording.service';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router } from '@angular/router';
import axios from 'src/app/Service/axios';
declare let $: any;
@Component({
  selector: 'voice-record-modal',
  templateUrl: './voice-record-modal.component.html',
  styleUrls: ['./voice-record-modal.component.css'],
})
export class VoiceRecordModalComponent implements OnInit, OnDestroy {
  @Input() modalId: string = 'voice-record-modal';
  @Input() strUnitId: string = '';
  @Output() voiceSent = new EventEmitter<string>();

  readonly maxRecordSeconds = 60;

  isAudioRecording = false;
  isSending = false;
  audioRecordedTime: any = '00:00';
  audioSrcUrl: any = '';
  strVoice: string = '';

  private subs: Subscription[] = [];

  constructor(
    private audioRecordingService: AudioRecordingService,
    private notify: NotificationService,
    private sanitizer: DomSanitizer,
    private ref: ChangeDetectorRef,
    private gurdService: GurdServiceService,
    private otherService: OtherService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.subscribeToAudioRecorder();
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
    this.audioRecordingService.abortRecording();
  }

  open(): void {
    this.reset();
    $(`#${this.modalId}`).modal('show');
  }

  close(): void {
    if (this.isAudioRecording) {
      this.audioRecordingService.stopRecording();
      this.isAudioRecording = false;
    }
    $(`#${this.modalId}`).modal('hide');
  }

  startAudioRecording(): void {
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(() => {
        if (!this.isAudioRecording) {
          this.isAudioRecording = true;
          this.audioRecordingService.startRecording();
        }
      })
      .catch((err) => {
        if (err.message == 'Requested device not found') {
          this.notify.showError('سیستم شما دارای میکروفون نمی باشد');
        } else {
          alert('خطا در ضبظ صدا');
        }
      });
  }

  stopAudioRecording(): void {
    if (!this.isAudioRecording) return;
    this.audioRecordingService.stopRecording();
    this.isAudioRecording = false;
    this.playAudio();
  }

  clearRecordedAudio(): void {
    this.strVoice = '';
    this.audioSrcUrl = '';
    this.audioRecordedTime = '00:00';
    this.notify.showSuccess('صدا با موفقیت حذف شد');
  }

  isAudioRecorded(): boolean {
    return !!this.strVoice;
  }

  async send(): Promise<void> {
    if (this.isSending) return;
    if (this.isAudioRecording)
      return this.notify.showError('ابتدا ضبط را متوقف کنید');
    if (!this.strVoice) return this.notify.showError('صدا را ضبط کنید');

    const strUnitID = this.resolveUnitId();
    if (!strUnitID) return this.notify.showError('خودرو مشخص نیست');

    this.isSending = true;
    this.otherService.Showspinner();
    try {
      const model = this.otherService.stringNumberToNumber({
        iSystemUser: this.gurdService.decrypt(
          window.localStorage.getItem('ID')!,
        ),
        strSession: this.gurdService.decrypt(
          window.localStorage.getItem('Session')!,
        ),
        lststrUnitIDs: [strUnitID],
        strVoice: this.strVoice,
      });

      const resp = await axios.post(`VS_Push2Talk`, model);
      const res = this.parseResponse(resp?.data);

      if (res?.ISSessionExpired == true) {
        this.notify.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        this.router.navigate(['login'], {
          queryParams: { error: 'Push2Talk' },
        });
        return;
      }

      if (!res || res.iResult == 0) {
        return this.notify.showError(res?.strError || 'خطا در ارسال صدا');
      }

      this.voiceSent.emit(this.strVoice);
      this.close();
      this.notify.showSuccess('با موفقیت ارسال شد.');
    } catch (err) {
      console.error('VS_Push2Talk error:', err);
      this.notify.showError('خطا در ارسال صدا');
    } finally {
      this.otherService.nonespinner();
      this.isSending = false;
    }
  }

  private resolveUnitId(): string {
    let raw = this.strUnitId;
    if (!raw) {
      const suffix = '-voice-record-modal';
      if (this.modalId?.endsWith(suffix)) {
        raw = this.modalId.slice(0, -suffix.length);
      }
    }
    if (!raw) return '';
    return raw.split('-')[0];
  }

  private parseResponse(data: any): any {
    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch {
        return null;
      }
    }
    return data;
  }

  private reset(): void {
    if (this.isAudioRecording) {
      this.audioRecordingService.abortRecording();
    }
    this.isAudioRecording = false;
    this.audioRecordedTime = '00:00';
    this.audioSrcUrl = '';
    this.strVoice = '';
  }

  private playAudio(): void {
    setTimeout(() => {
      if (this.strVoice) {
        this.audioSrcUrl = this.sanitizer.bypassSecurityTrustUrl(
          `data:audio/mp3;base64,` + this.strVoice,
        );
      }
    }, 200);
  }

  private blobToBase64(blob: any): Promise<unknown> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  private toSeconds(time: string): number {
    if (!time || time.indexOf(':') < 0) return 0;
    const parts = time.split(':');
    const m = parseInt(parts[0], 10) || 0;
    const s = parseInt(parts[1], 10) || 0;
    return m * 60 + s;
  }

  private subscribeToAudioRecorder(): void {
    this.subs.push(
      this.audioRecordingService.recordingFailed().subscribe(() => {
        this.isAudioRecording = false;
        this.ref.detectChanges();
      }),
    );

    this.subs.push(
      this.audioRecordingService.getRecordedTime().subscribe((time) => {
        this.audioRecordedTime = time;
        if (this.toSeconds(time) > this.maxRecordSeconds) {
          this.stopAudioRecording();
          this.notify.showError(
            `حداکثر زمان ضبط صدا ${this.maxRecordSeconds} ثانیه است`,
          );
        }
        this.ref.detectChanges();
      }),
    );

    this.subs.push(
      this.audioRecordingService.getRecordedBlob().subscribe((data) => {
        this.blobToBase64(data.blob).then((result: any) => {
          this.strVoice = result.replace('data:audio/wav;base64,', '');
        });
        this.audioSrcUrl = this.sanitizer.bypassSecurityTrustUrl(
          URL.createObjectURL(data.blob),
        );
        this.ref.detectChanges();
      }),
    );
  }

}
